module.exports = __webpack_public_path__ + "img/weitu.83e15d15.png";